import React                      from 'react'
import { Observer }               from 'mobx-react'
import { Button
       , Layout }                 from 'antd'

import { TEXT
       , tr }                     from '../00_assets'
import { ClientEditor
       , create_client_editor_model
       }                          from './02_screen_clients_editor'
import { avoid_closing_modal
       , ModalPrompt
       , Toolbar
       , VerFormInput }           from '../10_ui'

import { MClients }               from './01_screen_clients_model'
import { ClientsTable }           from './03_screen_clients_table'


export const ClientsScreen: React.FC = () =>
<Observer render={ ( ) =>
{
  const model   = MClients.instance( )
      , src     = model.clients.data_for_page( 0 )

  return <Layout.Content className="scrollable"> 
    <ClientsToolbar />
    <ClientsTable
      loading={ src.loading }
      clients={ src.data.slice( 0 ) }
      onDelete={ model.clients.on_delete }
      onEdit={ model.clients.on_edit }
    />
  </Layout.Content>
} } />



const ClientsToolbar: React.FC = () =>
<Observer render={ ( ) =>
{
  const model = MClients.instance( )

  return <Toolbar>
      <VerFormInput
        label={ TEXT.CLIENTS_FILTER_BY_NAME }
        className="mr-3"
        {...model.filter_name.bind}
      />

      <VerFormInput
        label={ TEXT.CLIENTS_FILTER_BY_ADDR }
        className="mr-3"
        {...model.filter_addr.bind}
      />

      <VerFormInput
        label={ TEXT.CLIENTS_FILTER_BY_CONTACT }
        className="mr-3"
        {...model.filter_contact.bind}
      />

      <NewClientButton />
    </Toolbar> ;
} } /> ;


const NewClientButton: React.FC = () =>
{
  const model   = MClients.instance( )
      , on_create = ( ) =>
        {
          const editor_model = create_client_editor_model( 
              { name: ''
              , surnames: ''
              , notes: ''
              , birthday: null
              , contact: null
              , address: null
              } as any ) ;

          ModalPrompt( tr( TEXT.CLIENT_NEW_TITLE )
                     , <ClientEditor form={ editor_model } />
                     , ( ) => 
                       {
                         if ( editor_model.has_errors( ) )
                              avoid_closing_modal( ) ;
                         else
                              model.clients.on_add( editor_model.fields( ) as any ) ;
                       }
                     , "plus"
                     ) ;

        } ;

  // TODO: <a href="">Descargar Doc</a> ?
  return <Observer render={ () => 
          <Button
            type="primary"
            className="ml-auto"
            onClick={ on_create }
          >
            { tr( TEXT.CLIENT_NEW_TITLE ) }
          </Button>
        } /> ;
} ;